import Icon from '@mui/icons-material/Person';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function PersonIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
